import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/auth';
import { useAuth } from './context/auth';
import { useRoles } from './hooks/useRoles';
import Header from './components/layout/Header';
import Hero from './components/sections/Hero';
import Features from './components/sections/Features';
import Services from './components/sections/Services';
import CTA from './components/sections/CTA';
import Footer from './components/layout/Footer';
import Login from './components/auth/Login';
import Signup from './components/auth/Signup';
import ForgotPassword from './components/auth/ForgotPassword';
import ProtectedRoute from './components/auth/ProtectedRoute';
import RoleProtectedRoute from './components/auth/RoleProtectedRoute';
import AuthLayout from './components/auth/AuthLayout';
import AdminDashboard from './components/admin/AdminDashboard';
import UserProfile from './components/profile/UserProfile';
import './styles/global.css';

// Home page component
const HomePage = () => {
  return (
    <div className="app">
      <Hero />
      <Features />
      <Services />
      <CTA />
    </div>
  );
};

// Dashboard component (protected)
const Dashboard = () => {
  const { currentUser, logout } = useAuth();
  const { roleLabel, canAccessAdminPanel } = useRoles();
  
  return (
    <div className="dashboard">
      <div className="dashboard-content">
        <h1>Welcome, {currentUser?.email}!</h1>
        <p>Role: {roleLabel}</p>
        <p>This is your protected dashboard.</p>
        
        <div className="dashboard-actions">
          <a href="/profile" className="profile-button">
            Edit My Profile
          </a>
          
          {canAccessAdminPanel && (
            <a href="/admin" className="admin-button">
              Access Admin Panel
            </a>
          )}
          
          <button onClick={logout} className="auth-button">
            Sign Out
          </button>
        </div>
      </div>
    </div>
  );
};

// Layout wrapper component
const Layout = ({ children }) => {
  return (
    <div className="app">
      <Header />
      {children}
      <Footer />
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/" element={
            <Layout>
              <HomePage />
            </Layout>
          } />
          <Route path="/login" element={
            <AuthLayout>
              <Login />
            </AuthLayout>
          } />
          <Route path="/signup" element={
            <AuthLayout>
              <Signup />
            </AuthLayout>
          } />
          <Route path="/forgot-password" element={
            <AuthLayout>
              <ForgotPassword />
            </AuthLayout>
          } />
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin" 
            element={
              <RoleProtectedRoute 
                requiredPermission="access_admin_panel"
                fallbackPath="/dashboard"
              >
                <Layout>
                  <AdminDashboard />
                </Layout>
              </RoleProtectedRoute>
            } 
          />
          <Route 
            path="/profile" 
            element={
              <ProtectedRoute>
                <Layout>
                  <UserProfile />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
};

export default App;
